import type React from 'react';

import { Toast } from '@heroui/react';

export function ToastRegion(): React.JSX.Element {
  return (
    <Toast.Provider placement="bottom start" className="z-110">
      {({ toast }) => {
        const { actionProps, description, title, variant } = toast.content;

        return (
          <Toast key={toast.key} toast={toast} variant={variant}>
            <Toast.Content>
              {title ? <Toast.Title>{title}</Toast.Title> : null}
              {description ? <Toast.Description>{description}</Toast.Description> : null}
              {actionProps?.children ? (
                <Toast.ActionButton onPress={actionProps.onPress ?? (() => undefined)}>
                  {actionProps.children}
                </Toast.ActionButton>
              ) : null}
            </Toast.Content>
            <Toast.CloseButton />
          </Toast>
        );
      }}
    </Toast.Provider>
  );
}
